import { Component, Renderer2, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-home',
  templateUrl: './new-home.component.html',
  styleUrls: ['./new-home.component.scss']
})
export class NewHomeComponent implements OnInit {
  [x: string]: any;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    
  }
  ngAfterViewInit() {
    // Add a class to the body element
    //this.renderer.addClass(document.body, 'bg-black');
  }
  ngOnDestroy() {
    // Remove the class from the body element
    this.renderer.removeClass(document.body, 'bg-black');
  }

  LoginPage(){
    this.router.navigate(['/login']);
  }

}
